module.exports = __webpack_public_path__ + "sciezka3.png?ef21ef76fced90d6b9ad391b58c48855";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sciezka3.png
// module id = 29
// module chunks = 0